__turbopack_context__.v({
  "address": "Address-module-scss-module__OU5rRG__address",
  "description": "Address-module-scss-module__OU5rRG__description",
  "name": "Address-module-scss-module__OU5rRG__name",
});
